import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { PageHeader } from "@/components";

import { IntegrationCategory } from "../constants/catalog";
import { useVisibleCatalogEntries } from "../hooks/useVisibleCatalogEntries";
import { IntegrationCard } from "./IntegrationCard";

const CATEGORY_ORDER: IntegrationCategory[] = [
	"crm",
	"outreachTools",
	"aiTools",
	"automation",
	"developer",
];

export const IntegrationsCatalog: FunctionComponent = () => {
	const { t } = useTranslation();
	const visibleEntries = useVisibleCatalogEntries();

	return (
		<div className="flex flex-col w-full">
			<PageHeader title={t("integrations.title")} />

			<div className="flex flex-col gap-8">
				{CATEGORY_ORDER.map((category) => {
					const entries = visibleEntries.filter((entry) => entry.category === category);

					if (entries.length === 0) {
						return null;
					}

					return (
						<section key={category} className="flex flex-col gap-3">
							<h2 className="text-text text-md font-medium">
								{t(`integrations.categories.${category}`)}
							</h2>
							<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
								{entries.map((entry) => (
									<IntegrationCard key={entry.id} entry={entry} />
								))}
							</div>
						</section>
					);
				})}
			</div>
		</div>
	);
};
